import "./middle.css"
import { useContext, useEffect, useState } from "react"
import { AuthContext } from "../../context/AuthContext"
import Map from "../../components/map/Map"
import MissionDetail from "../../components/missionDetail/MissionDetail"
import { MiddleSwitchContainer } from "../../components/middleSwitchContainer/MiddleSwitchContainer"
import { useDrop } from "react-dnd"
import { ItemTypes } from "../../ItemTypes"
import IukDrop from "../../components/iukdrop/IukDrop"
export default function Middle({ selectedMission, setSelectedMission, missions, setmissions }) {

  const [{ canDrop }, dropZone ] = useDrop({
    accept: ItemTypes.MISSION,
    drop: () => ({ name: "Middle"}),
    collect: (monitor) => ({
      canDrop: monitor.canDrop(),
    }),
  });

  const Dashboard = () => {
    return (
    <>
        <div className="middleBottom">Bottom, when nothing selected show Heatmap. When Gemeinde Selected, show Gemeinde Headmap. When Mission selected, show Mission Details</div>
        <div className="middleMap">
          <Map />
        </div>
    </>
    )
  }

  return (
    <div className="middle">
      <div className="middleWrapper">
        <div className="middleTop">
          <div className="missionStates">
            <div className="missionStateOpen">0</div>
            <div className="missionStateInProgress">5</div>
            <div className="missionStateFinished">23</div>
          </div>
        </div>
        <span>Header with Mission State, when Gemeinde selected show Mission State from Gemeinde</span>
        <span>3 Colums, first open, middle in Progress, last Finished Missions</span>
        <hr className="shareHr" />
        <div className="middleMain" ref={dropZone}>
          {canDrop ? 
            <IukDrop />
            :
            <MiddleSwitchContainer 
            selectedMission={selectedMission} 
            setSelectedMission={setSelectedMission} 
            missions={missions}
            setmissions={setmissions}/>
            //<IukDrop />
          }
        </div>
      </div>
    </div>
  )
}
